import { History } from "history";

import {
  CreateChapterRequest,
  PaginateQuery,
  UpdateChapterRequest,
  ChapterDto,
  ChapterStatsDto,
  ChapterSkillsStatsDto,
  ChapterFlashCardsStatsDto,
  ChapterLecturesStatsDto,
  OrganizingChapterDto,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Chapters

export const GET_CHAPTERS = "GET_CHAPTERS";
export const GET_CHAPTERS_SUCCESS: any = "GET_CHAPTERS_SUCCESS";
export const GET_CHAPTERS_ERROR: any = "GET_CHAPTERS_ERROR";

export interface GetChaptersAction {
  type: typeof GET_CHAPTERS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetChaptersSuccessAction {
  type: typeof GET_CHAPTERS_SUCCESS;
  payload: Paginated<ChapterDto>;
}

export interface GetChaptersErrorAction {
  type: typeof GET_CHAPTERS_ERROR;
  payload: any;
}
//#endregion

//#region Get Chapters Stats

export const GET_CHAPTERS_STATS = "GET_CHAPTERS_STATS";
export const GET_CHAPTERS_STATS_SUCCESS: any = "GET_CHAPTERS_STATS_SUCCESS";
export const GET_CHAPTERS_STATS_ERROR: any = "GET_CHAPTERS_STATS_ERROR";

export interface GetChaptersStatsAction {
  type: typeof GET_CHAPTERS_STATS;
  payload: {
    subjectId: string;
    history: History;
  };
}

export interface GetChaptersStatsSuccessAction {
  type: typeof GET_CHAPTERS_STATS_SUCCESS;
  payload: ChapterStatsDto[];
}

export interface GetChaptersStatsErrorAction {
  type: typeof GET_CHAPTERS_STATS_ERROR;
  payload: any;
}
//#endregion

//#region Get Chapter

export const GET_CHAPTER = "GET_CHAPTER";
export const GET_CHAPTER_SUCCESS: any = "GET_CHAPTER_SUCCESS";
export const GET_CHAPTER_ERROR: any = "GET_CHAPTER_ERROR";

export interface GetChapterAction {
  type: typeof GET_CHAPTER;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetChapterSuccessAction {
  type: typeof GET_CHAPTER_SUCCESS;
  payload: ChapterDto;
}

export interface GetChapterErrorAction {
  type: typeof GET_CHAPTER_ERROR;
  payload: any;
}
//#endregion

//#region Add Chapter

export const ADD_CHAPTER = "ADD_CHAPTER";
export const ADD_CHAPTER_SUCCESS: any = "ADD_CHAPTER_SUCCESS";
export const ADD_CHAPTER_ERROR: any = "ADD_CHAPTER_ERROR";

export interface AddChapterAction {
  type: typeof ADD_CHAPTER;
  payload: {
    request: CreateChapterRequest;
    history: History;
  };
}

export interface AddChapterSuccessAction {
  type: typeof ADD_CHAPTER_SUCCESS;
  payload: null;
}

export interface AddChapterErrorAction {
  type: typeof ADD_CHAPTER_ERROR;
  payload: any;
}
//#endregion

//#region Update Chapter

export const UPDATE_CHAPTER = "UPDATE_CHAPTER";
export const UPDATE_CHAPTER_SUCCESS: any = "UPDATE_CHAPTER_SUCCESS";
export const UPDATE_CHAPTER_ERROR: any = "UPDATE_CHAPTER_ERROR";

export interface UpdateChapterAction {
  type: typeof UPDATE_CHAPTER;
  payload: {
    id: string;
    request: UpdateChapterRequest;
    history: History;
  };
}

export interface UpdateChapterSuccessAction {
  type: typeof UPDATE_CHAPTER_SUCCESS;
  payload: null;
}

export interface UpdateChapterErrorAction {
  type: typeof UPDATE_CHAPTER_ERROR;
  payload: any;
}
//#endregion

//#region Delete Chapter

export const DELETE_CHAPTER_CONSENT: any = "DELETE_CHAPTER_CONSENT";
export const DELETE_CHAPTER = "DELETE_CHAPTER";
export const DELETE_CHAPTER_SUCCESS: any = "DELETE_CHAPTER_SUCCESS";
export const DELETE_CHAPTER_ERROR: any = "DELETE_CHAPTER_ERROR";

export interface DeleteChapterConsentAction {
  type: typeof DELETE_CHAPTER_CONSENT;
  payload: string;
}

export interface DeleteChapterAction {
  type: typeof DELETE_CHAPTER;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteChapterSuccessAction {
  type: typeof DELETE_CHAPTER_SUCCESS;
  payload: null;
}

export interface DeleteChapterErrorAction {
  type: typeof DELETE_CHAPTER_ERROR;
  payload: any;
}
//#endregion

//#region Get Chapters Stats for Skills

export const GET_CHAPTERS_SKILLS_STATS = "GET_CHAPTERS_SKILLS_STATS";
export const GET_CHAPTERS_SKILLS_STATS_SUCCESS: any =
  "GET_CHAPTERS_SKILLS_STATS_SUCCESS";
export const GET_CHAPTERS_SKILLS_STATS_ERROR: any =
  "GET_CHAPTERS_SKILLS_STATS_ERROR";

export interface GetChaptersSkillsStatsAction {
  type: typeof GET_CHAPTERS_SKILLS_STATS;
  payload: {
    subjectId: string;
    history: History;
  };
}

export interface GetChaptersSkillsStatsSuccessAction {
  type: typeof GET_CHAPTERS_SKILLS_STATS_SUCCESS;
  payload: ChapterSkillsStatsDto[];
}

export interface GetChaptersSkillsStatsErrorAction {
  type: typeof GET_CHAPTERS_SKILLS_STATS_ERROR;
  payload: any;
}
//#endregion

//#region Get Chapters Stats for Flash Cards

export const GET_CHAPTERS_FLASH_CARDS_STATS = "GET_CHAPTERS_FLASH_CARDS_STATS";
export const GET_CHAPTERS_FLASH_CARDS_STATS_SUCCESS: any =
  "GET_CHAPTERS_FLASH_CARDS_STATS_SUCCESS";
export const GET_CHAPTERS_FLASH_CARDS_STATS_ERROR: any =
  "GET_CHAPTERS_FLASH_CARDS_STATS_ERROR";

export interface GetChaptersFlashCardsStatsAction {
  type: typeof GET_CHAPTERS_FLASH_CARDS_STATS;
  payload: {
    subjectId: string;
    history: History;
  };
}

export interface GetChaptersFlashCardsStatsSuccessAction {
  type: typeof GET_CHAPTERS_FLASH_CARDS_STATS_SUCCESS;
  payload: ChapterFlashCardsStatsDto[];
}

export interface GetChaptersFlashCardsStatsErrorAction {
  type: typeof GET_CHAPTERS_FLASH_CARDS_STATS_ERROR;
  payload: any;
}
//#endregion

//#region Toggle Chapter State

export const TOGGLE_CHAPTER_STATE_CONSENT: any = "TOGGLE_CHAPTER_STATE_CONSENT";
export const TOGGLE_CHAPTER_STATE = "TOGGLE_CHAPTER_STATE";
export const TOGGLE_CHAPTER_STATE_SUCCESS: any = "TOGGLE_CHAPTER_STATE_SUCCESS";
export const TOGGLE_CHAPTER_STATE_ERROR: any = "TOGGLE_CHAPTER_STATE_ERROR";

export interface ToggleChapterStateConsentAction {
  type: typeof TOGGLE_CHAPTER_STATE_CONSENT;
  payload: string;
}

export interface ToggleChapterStateAction {
  type: typeof TOGGLE_CHAPTER_STATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface ToggleChapterStateSuccessAction {
  type: typeof TOGGLE_CHAPTER_STATE_SUCCESS;
  payload: { id: string };
}

export interface ToggleChapterStateErrorAction {
  type: typeof TOGGLE_CHAPTER_STATE_ERROR;
  payload: any;
}
//#endregion

//#region Get Chapters Stats for Lectures

export const GET_CHAPTERS_LECTURES_STATS = "GET_CHAPTERS_LECTURES_STATS";
export const GET_CHAPTERS_LECTURES_STATS_SUCCESS: any =
  "GET_CHAPTERS_LECTURES_STATS_SUCCESS";
export const GET_CHAPTERS_LECTURES_STATS_ERROR: any =
  "GET_CHAPTERS_LECTURES_STATS_ERROR";

export interface GetChaptersLecturesStatsAction {
  type: typeof GET_CHAPTERS_LECTURES_STATS;
  payload: {
    subjectId: string;
    history: History;
  };
}

export interface GetChaptersLecturesStatsSuccessAction {
  type: typeof GET_CHAPTERS_LECTURES_STATS_SUCCESS;
  payload: ChapterLecturesStatsDto[];
}

export interface GetChaptersLecturesStatsErrorAction {
  type: typeof GET_CHAPTERS_LECTURES_STATS_ERROR;
  payload: any;
}
//#endregion

//#region chapter select list by subject

export const GET_CHAPTER_LIST_BY_SUBJECT = "GET_CHAPTER_LIST_BY_SUBJECT";
export const GET_CHAPTER_LIST_BY_SUBJECT_SUCCESS: any =
  "GET_CHAPTER_LIST_BY_SUBJECT_SUCCESS";
export const GET_CHAPTER_LIST_BY_SUBJECT_ERROR: any =
  "GET_CHAPTER_LIST_BY_SUBJECT_ERROR";

export const RESET_CHAPTER_LIST_BY_SUBJECT: any =
  "RESET_CHAPTER_LIST_BY_SUBJECT";

export interface GetChapterSelectListBySubjectAction {
  type: typeof GET_CHAPTER_LIST_BY_SUBJECT;
  payload: { subjectId: string };
}

export interface GetChapterSelectListBySubjectSuccessAction {
  type: typeof GET_CHAPTER_LIST_BY_SUBJECT_SUCCESS;
  payload: SelectListDto[];
}

export interface GetChapterSelectListBySubjectErrorAction {
  type: typeof GET_CHAPTER_LIST_BY_SUBJECT_ERROR;
  payload: any;
}

export interface ResetChapterListBySubjectAction {
  type: typeof RESET_CHAPTER_LIST_BY_SUBJECT;
  payload: any;
}

//#endregion

//#region Get Organizing Chapters

export const GET_ORGANIZING_CHAPTERS = "GET_ORGANIZING_CHAPTERS";
export const GET_ORGANIZING_CHAPTERS_SUCCESS: any =
  "GET_ORGANIZING_CHAPTERS_SUCCESS";
export const GET_ORGANIZING_CHAPTERS_ERROR: any =
  "GET_ORGANIZING_CHAPTERS_ERROR";

export interface GetOrganizingChaptersAction {
  type: typeof GET_ORGANIZING_CHAPTERS;
  payload: {
    query: PaginateQuery;
    subjectId: string;
    history: History;
  };
}

export interface GetOrganizingChaptersSuccessAction {
  type: typeof GET_ORGANIZING_CHAPTERS_SUCCESS;
  payload: Paginated<OrganizingChapterDto>;
}

export interface GetOrganizingChaptersErrorAction {
  type: typeof GET_ORGANIZING_CHAPTERS_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetChaptersAction
  | GetChaptersSuccessAction
  | GetChaptersErrorAction
  | GetChaptersStatsAction
  | GetChaptersStatsSuccessAction
  | GetChaptersStatsErrorAction
  | GetChapterAction
  | GetChapterSuccessAction
  | GetChapterErrorAction
  | AddChapterAction
  | AddChapterSuccessAction
  | AddChapterErrorAction
  | UpdateChapterAction
  | UpdateChapterSuccessAction
  | UpdateChapterErrorAction
  | DeleteChapterConsentAction
  | DeleteChapterAction
  | DeleteChapterSuccessAction
  | DeleteChapterErrorAction
  | GetChaptersSkillsStatsAction
  | GetChaptersSkillsStatsSuccessAction
  | GetChaptersSkillsStatsErrorAction
  | GetChaptersFlashCardsStatsAction
  | GetChaptersFlashCardsStatsSuccessAction
  | GetChaptersFlashCardsStatsErrorAction
  | ToggleChapterStateConsentAction
  | ToggleChapterStateAction
  | ToggleChapterStateSuccessAction
  | ToggleChapterStateErrorAction
  | GetChaptersLecturesStatsAction
  | GetChaptersLecturesStatsSuccessAction
  | GetChaptersLecturesStatsErrorAction
  | GetChapterSelectListBySubjectAction
  | GetChapterSelectListBySubjectErrorAction
  | GetChapterSelectListBySubjectSuccessAction
  | GetOrganizingChaptersAction
  | GetOrganizingChaptersSuccessAction
  | GetOrganizingChaptersErrorAction;
